import { Box } from "@mui/system";
import { Handyman } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import { Tooltip } from "@mui/material";
import { Switch } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { ToolView } from "@my-helpers/common";

interface ToolHeaderProps {
    isLoading?: string;
    currentTool?: ToolView;
    toggleUserToolStatus: (toolId: string, enabled: boolean) => void;
}

export const ToolHeader: React.FC<ToolHeaderProps> = (
    { isLoading, currentTool, toggleUserToolStatus }) => {

    const navigate = useNavigate();

    const handleToggleStatus = useCallback(() => {
        if (!currentTool) return;
        toggleUserToolStatus(currentTool.id, !currentTool.user_enabled);
    }, [currentTool, toggleUserToolStatus]);


    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3
        }}>
            <Handyman sx={{
                fontSize: '2.6rem',
                color: 'primary.main'
            }} />
            <Box sx={{ flexGrow: 1 }}>
                <Typography
                    variant="h6"
                    color="primary"
                    sx={{
                        fontWeight: 400,
                        fontSize: '1.5rem',
                        padding: '4px 0',
                    }}>
                    {!isLoading && currentTool ? currentTool.provider : 'Tool'}
                </Typography>
            </Box>

            <Tooltip title="Back to tools">
                <IconButton
                    onClick={() => navigate('/tools')}
                    sx={{
                        color: 'primary.light',
                        backgroundColor: 'lightGray',
                        flexShrink: 0,
                        '&:hover': {
                            color: 'white',
                            backgroundColor: 'primary.light',
                        }
                    }}
                >
                    <ArrowBack />
                </IconButton>
            </Tooltip>
            <Switch
                checked={!isLoading && currentTool ? currentTool.user_enabled : false}
                onChange={handleToggleStatus}
                color="primary"
            />
        </Box>
    );
};
